<template>
  <div class="searchButtons">
    <ExtendedSearch
        :table-model="tableModel"
        :search-params="searchParams"
        @search="search"
        @reset-search="resetForm"
    >
        <template v-slot:searchItems>
            <div class="searchItem"
                v-if="isAdmin"
            >
                <Customer
                    :search-params="searchParams"
                />
            </div>
            <div class="searchItem">
                <ProcedureStep
                    :procedure-steps="procedureSteps"
                    :search-params="searchParams"
                />
            </div>
            <div class="searchItem mt-0" v-if="!isPublicRoute && !isOrg && !isAdmin">
                <ProcedureCategories
                    :contragent="user.opts.contragent"
                    :search-params="searchParams"
                    @search="search"
                />
            </div>
            <div class="searchItem">
                <ProcedureType
                    :procedure-types="procedureTypes"
                    :search-params="searchParams"
                />
            </div>
            <div
                v-if="false"
                class="searchItem"
            >
                <ProcedureAccessibility
                    :search-params="searchParams"
                />
            </div>
            <div class="searchItem">
                <ApplicationDeadline
                    :search-params="searchParams"
                />
            </div>
            <div class="searchItem">
                <StartMaxPrice
                    :search-params="searchParams"
                />
            </div>
        </template>
    </ExtendedSearch>
  </div>
</template>

<script>
import api from '@/api';
import ExtendedSearch from "@intec/vue-components/search/ExtendedSearch.vue";
import Customer from "./extendedSearch/Customer.vue";
import ProcedureStep from "./extendedSearch/ProcedureStep.vue";
import ProcedureCategories from "./extendedSearch/ProcedureCategories.vue"
import ProcedureType from "./extendedSearch/ProcedureType.vue";
import ApplicationDeadline from "./extendedSearch/ApplicationDeadline.vue";
import StartMaxPrice from "./extendedSearch/StartMaxPrice.vue";
import ProcedureAccessibility from './extendedSearch/ProcedureAccessibility.vue';
import Config from '@/config';
import { useProcedureStepStore } from '@/stores/procedureStepStore'
import { useRoute } from "vue-router";

export default {
    name: 'ProcedureExtendedSearch',
    components: {
        ProcedureAccessibility,
        ExtendedSearch,
        Customer,
        ProcedureStep,
        ProcedureCategories,
        ProcedureType,
        ApplicationDeadline,
        StartMaxPrice,
    },
    props: {
        tableModel: {
            type: Object,
            required: true,
        },
        resetSearch: {
            type: Function,
        },
    },
    data() {
        let user = Config.getUser();
        const procedureStepStore = useProcedureStepStore();
        const route = useRoute();
        const isPublicRoute = route.name === 'public.procedures';

        return {
            user: user,
            searchParams: {
                customers: [],
                steps: [],
                categories: [],
                types: [],
                applicationDeadline: {
                    dates: []
                },
                startMaxPrice: {
                    from: null,
                    to: null,
                },
                isClosed: null
            },
            procedureSteps: procedureStepStore.getProcedureSteps(user),
            procedureTypes: Config.get('procedureTypes') || [],
            isOrg: user.hasRole('ROLE_CUSTOMER'),
            isPublicRoute,
            isAdmin: user.hasRole('ROLE_ADMIN')
        };
    },
    async created() {
      if (this.isPublicRoute) {
        const procedureStepStore = useProcedureStepStore();
        const publishedStep = procedureStepStore.getStepByCodeAndRound(procedureStepStore.PUBLISHED)
        const steps = []
        if (publishedStep) {
          steps.push(publishedStep)
        }
        this.searchParams.steps = steps;
        this.tableModel.bind.options.searchParams = {
          steps: steps
        };
      }

      try {
        this.procedureTypes = await api.get('/procedures/getTypes');
      } catch (error) {
        console.error('Ошибка при получении типов процедур:', error);
      }
    },
    methods: {
        search() {
            let options = {
                searchParams: this.searchParams
            };
            this.tableModel.bind.options.page = 1;
            this.tableModel.reload(options);
        },
        resetForm() {
            if (this.isPublicRoute) {
              this.tableModel.bind.options.searchParams = {};
            }

            this.searchParams.steps = [];
            this.searchParams.categories = [];
            this.searchParams.types = [];
            this.searchParams.customers = [];
            this.searchParams.applicationDeadline.dates = [];
            this.searchParams.startMaxPrice.from = null;
            this.searchParams.startMaxPrice.to = null;
            this.searchParams.isClosed = null;
            this.$emit('resetSearch');
        },
    },
}
</script>

<style scoped>
:deep(.searchButtons .buttons) {
  justify-content: flex-start;
}
</style>
